import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { generateOptions, generateUrl } from '../AdditionalOrderForm/utils';
import { Wrapper } from './style';
import { EligibleItems } from './EligibleItems';
import { useMultiOrder } from './hooks/useMultiOrder';
import { IneligibleItems } from './IneligibleItems';

const mapStateToProps = (state) => {
  const {
    page: { browserFingerprint, productType, locale, giftOrder, initialPageLoadParams },
    landingPage: { landingForm },
    retailerSettings: { name: retailerMoniker = '' },
    multiOrders: { orders, error },
    orderInfo,
    language,
  } = state;

  const stateSecondFactor = Object.entries(landingForm).reduce(
    (acc, [key, value]) =>
      key.includes('email') || key.includes('zip')
        ? { ...acc, [key === 'zip' ? 'bzip' : key]: value }
        : acc,
    {},
  );

  return {
    getUrl: generateUrl({
      stateSecondFactor,
      productType,
      locale,
      giftOrder,
      initialPageLoadParams,
      retailerMoniker,
    }),
    options: generateOptions({ browserFingerprint }),
    twoFaType: Object.keys(landingForm).includes('zip') ? 'bzip' : 'email',
    orders,
    errorMessage: error,
    orderInfo,
    locale,
    language,
  };
};

const ItemsComponent = ({ itemSidebar, ineligible }) => {
  const { byDay, ineligibleByDay, returnCart, items, naItems, orderGroups, allOrders } =
    useMultiOrder();

  const onSelectItem = ({ item: payload, orderNumber }) => {
    itemSidebar({ item: payload, orderNumber });
  };

  return (
    <Wrapper>
      {!ineligible && (
        <EligibleItems
          showGroups={allOrders.length > 1}
          orderGroups={orderGroups}
          onSelectItem={onSelectItem}
          returnCart={returnCart}
          items={byDay || items}
        />
      )}
      {ineligible && <IneligibleItems {...{ ineligibleByDay, naItems }} />}
    </Wrapper>
  );
};

export const Items = connect(mapStateToProps)(ItemsComponent);

ItemsComponent.defaultProps = {
  orders: [],
  orderInfo: null,
  services: {},
  itemSidebar: () => {},
  ineligible: false,
};

ItemsComponent.propTypes = {
  orders: PropTypes.arrayOf(PropTypes.object),
  orderInfo: PropTypes.object,
  services: PropTypes.object,
  itemSidebar: PropTypes.func,
  ineligible: PropTypes.bool,
};
